module.exports = __webpack_public_path__ + "static/media/save.2e6b9fff.svg";